export default "__VITE_ASSET__B8_kxmZW__"